// ---------------------------------------------------------------------------
// Hash
// ---------------------------------------------------------------------------

/**
 * FNV-1a 32-bit hash of a string, returned as a hex string.
 * Fast and deterministic — suitable for local rift cache keys.
 */
export const fnv1aHash = (str: string): string => {
  let hash = 0x811c9dc5; // FNV offset basis
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193); // FNV prime
  }
  return (hash >>> 0).toString(16);
};

/**
 * Hashes SQL with its run id to avoid stale entry reuse across publishes that
 * produce identical SQL text. Because runs are immutable, `runId` is a complete
 * version boundary.
 */
export const getVersionedRiftId = (sql: string, runId: string): string =>
  fnv1aHash(`${runId}:${sql}`);
